module.exports = __webpack_public_path__ + "static/media/logo.715029d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 603
// module chunks = 37